/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "pagination": {
      "goto": "Go to",
      "pagesize": "/page",
      "total": "{total} results",
      "pageClassifier": "page"
    }
  },
  "de-DE": {
    "pagination": {
      "goto": "Gehe nach",
      "pagesize": "/Seite",
      "total": "{total} Ergebnisse",
      "pageClassifier": "Seite"
    }
  },
  "es-ES": {
    "pagination": {
      "goto": "Ir a",
      "pagesize": "/página",
      "total": "{total} resultados",
      "pageClassifier": "página"
    }
  },
  "fr-FR": {
    "pagination": {
      "goto": "Aller à",
      "pagesize": "/page",
      "total": "{total} résultats",
      "pageClassifier": "page"
    }
  },
  "it-IT": {
    "pagination": {
      "goto": "Vai a",
      "pagesize": "/pagina",
      "total": "{total} risultati",
      "pageClassifier": "pagina"
    }
  },
  "jp-JP": {
    "pagination": {
      "goto": "移動先：",
      "pagesize": "/ページ",
      "total": "{total}件の結果",
      "pageClassifier": "ページ"
    }
  },
  "ko-KO": {
    "pagination": {
      "goto": "다음으로 이동",
      "pagesize": "/페이지",
      "total": "결과 {total}개",
      "pageClassifier": "페이지"
    }
  },
  "pl-PL": {
    "pagination": {
      "goto": "Przejdź do",
      "pagesize": "/strona",
      "total": "{total} wyników",
      "pageClassifier": "strona"
    }
  },
  "pt-PT": {
    "pagination": {
      "goto": "Ir para",
      "pagesize": "/página",
      "total": "{total} resultados",
      "pageClassifier": "página"
    }
  },
  "ru-RU": {
    "pagination": {
      "goto": "Перейти к",
      "pagesize": "/с.",
      "total": "Результатов: {total}",
      "pageClassifier": "с."
    }
  },
  "tr-TR": {
    "pagination": {
      "goto": "Şuraya git",
      "pagesize": "/sayfa",
      "total": "{total} sonuç",
      "pageClassifier": "sayfa"
    }
  },
  "vi-VN": {
    "pagination": {
      "goto": "Đến",
      "pagesize": "/trang",
      "total": "{total} kết quả",
      "pageClassifier": "trang"
    }
  },
  "zh-CN": {
    "pagination": {
      "goto": "前往",
      "pagesize": "/页",
      "total": "{total}个结果",
      "pageClassifier": "页面"
    }
  },
  "zh-TW": {
    "pagination": {
      "goto": "移至",
      "pagesize": "/頁",
      "total": "{total}個結果",
      "pageClassifier": "頁"
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
